module.exports = __webpack_public_path__ + "static/media/tweetme.2185e423.PNG";